import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../../common/Button";

const Header = () => {

  const history = useHistory();

  return (
    <div className="header">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <Button className="btn-close-wrap" onClick={ history.goBack }>닫기</Button>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Header;
